import { useUpdateUsers } from '../../../api';
import { useCallback } from 'react';
import { showAlert } from '@silverfort/sf-components';
import { User } from '../../../types/User';

interface useResumeProtectionParams {
    users: User[];
    onProtectionResumed?: () => void;
}

const useResumeProtection = ({ users, onProtectionResumed }: useResumeProtectionParams) => {
    const handleUserProtectionResumed = useCallback(() => {
        showAlert(
            `Protection resumed for ${users.length > 1 ? users.length + ' users' : users[0].displayName}`,
            'success'
        );

        onProtectionResumed?.();
    }, [onProtectionResumed, users]);

    const handleUserProtectionResumedError = useCallback(() => {
        showAlert('Failed to resume protection, please try again', 'error');
    }, []);

    const { updateUsers } = useUpdateUsers({
        onSuccess: handleUserProtectionResumed,
        onError: handleUserProtectionResumedError
    });

    const handleResumeProtection = () => {
        if (users?.length) {
            updateUsers(users.map(({ guid }) => ({ guid, excludeTill: null })));
        }
    };

    return { handleResumeProtection };
};

export default useResumeProtection;
